import {useRouteMatch, Switch, Route, Redirect} from 'react-router-dom';

// import Users from './Users';
import Employees from './Employees';
import Vehicles from './Vehicles';
import Routes from './Routes';
// import Prescribers from './Prescribers';

import styles from './Settings.module.scss';
import {useEffect} from 'react';
import useUi from 'hooks/useUi';
import Products from 'pages/Products';

function Settings() {
  const {path} = useRouteMatch();
  const {setSidebarExtended, setFullsizeContent} = useUi();

  useEffect(
    function () {
      setSidebarExtended(false);
      setFullsizeContent(true);

      return function () {
        setSidebarExtended(true);
        setFullsizeContent(false);
      };
    },
    [setSidebarExtended, setFullsizeContent]
  );

  return (
    <div className={styles.root}>
      <Switch>
        <Route path={`${path}/products`} component={Products} />
        <Route path={`${path}/employees`} component={Employees} />
        <Route path={`${path}/vehicles`} component={Vehicles} />
        <Route path={`${path}/routes`} component={Routes} />
        {/* <Route path={`${path}/prescribers`} component={Prescribers} /> */}
        <Redirect to={`${path}/products`} />
      </Switch>
    </div>
  );
}

export default Settings;
